import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import BackButton from "../../../../components/BackButton";
import BaseIcon from "../../../../components/BaseIcon";
import ROUTES from "../../../../utils/routes";
import config from "../../../../config";
import "./style.scss";

const LANGUAGES = [
  { value: "en", label: "EN" },
  { value: "ru", label: "RU" },
];

export default function SectionPageHeader() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [isLangOpen, setIsLangOpen] = useState(false);
  const langWrapperRef = useRef(null);

  const onSelectLang = async (lang) => {
    setIsLangOpen(false);
    if (lang === i18n.language) return;
    await i18n.changeLanguage(lang);
  };

  useEffect(() => {
    if (!isLangOpen) return undefined;
    const onDocClick = (e) => {
      if (
        langWrapperRef.current &&
        !langWrapperRef.current.contains(e.target)
      ) {
        setIsLangOpen(false);
      }
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [isLangOpen]);

  const host =
    typeof window !== "undefined" && window.location
      ? window.location.hostname.toLowerCase()
      : "";
  const isRu = host.endsWith("wepurplay.ru");
  const isCom = host.endsWith("wepurplay.com");
  const isInTouch = host.endsWith("in-touch.space");

  const onBackClick = () => {
    if (isInTouch || isCom) {
      // На .com и .space "Главная" ведёт на лендинг in-touch.space
      const url =
        i18n.language.toLowerCase() === "en"
          ? `home-${i18n.language}/?lang=${i18n.language}`
          : "?lang=" + i18n.language;
      window.location.replace(config.prod_domain + url);
    } else {
      window.location.replace(
        `${window.location.origin}/?lang=${i18n.language}`
      );
    }
  };

  return (
    <header className="section-page-header">
      {isRu ? (
        <div className="section-page-header__btn-back-placeholder" />
      ) : (
        <BackButton
          title={t("section_main_title.main_menu")}
          onClick={onBackClick}
          className="section-page-header__btn-back"
        />
      )}
      <div className="section-page-header__right">
        <button
          type="button"
          onClick={() => navigate(ROUTES.LOGIN_PAGE)}
          className="section-page-header__btn-login"
        >
          {/* 29.10: тот же SVG «Вход», что в шапках игры и партнёрки (раньше PNG) */}
          <BaseIcon
            name="login"
            className="section-page-header__btn-login__icon"
          />
          <span>{t("logIn")}</span>
        </button>
        {!isRu && (
          <div
            className="section-page-header__lang-wrapper"
            ref={langWrapperRef}
          >
            <button
              type="button"
              onClick={() => setIsLangOpen((v) => !v)}
              className="section-page-header__btn-lang"
              aria-haspopup="listbox"
              aria-expanded={isLangOpen}
              aria-label={t("change_language") || "Change language"}
            >
              <BaseIcon
                name="globe"
                className="section-page-header__btn-lang__globe"
              />
              <BaseIcon
                name="lang_chevrons"
                className="section-page-header__btn-lang__chevrons"
              />
            </button>
            {isLangOpen && (
              <ul
                className="section-page-header__lang-dropdown"
                role="listbox"
              >
                {LANGUAGES.map(({ value, label }) => (
                  <li
                    key={value}
                    role="option"
                    aria-selected={i18n.language === value}
                    className={
                      "section-page-header__lang-dropdown__item" +
                      (i18n.language === value
                        ? " section-page-header__lang-dropdown__item_active"
                        : "")
                    }
                    onClick={() => onSelectLang(value)}
                  >
                    {label}
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
      </div>
    </header>
  );
}
